import produce from 'immer';
import { CountingPattern } from '~/domain/model';
import { createCreator, createReducer, Reducer } from '~/helpers/util/reducers';

export type CountingPatternsState = {
  byId: Map<number, CountingPattern>;
};

export type Update = {
  byId: Map<number, CountingPattern>;
};

const prefix = '@countingPatterns';

export const Types = Object.freeze({
  CLEAR: `${prefix}/CLEAR`,
  UPDATE: `${prefix}/UPDATE`
});

export const initialState: CountingPatternsState = {
  byId: new Map()
};

const clearReducer: Reducer<CountingPatternsState, void> = state => {
  return produce(state, draft => {
    draft.byId = initialState.byId;
  });
};

const updateReducer: Reducer<CountingPatternsState, Update> = (
  state,
  action
) => {
  return produce(state, draft => {
    draft.byId = action.byId as Map<number, CountingPattern>;
  });
};

export const actions = Object.freeze({
  clear: createCreator<void>(Types.CLEAR),
  update: createCreator<Update>(Types.UPDATE)
});

export const reducer = createReducer(initialState, {
  [Types.CLEAR]: clearReducer,
  [Types.UPDATE]: updateReducer
});
